import moment from 'moment';
import { DetenteurEntity } from '../../../../entities/detenteur.entity';
import {
  ExportFormat,
  ExportMetadata,
  exportPremiumFile,
} from '../../../../shared/exportFiles';

export const generateDetenteurDataToExport = (detenteurs: any[]) => {
  let toExport: any[] = [];
  let index = 1;
  for (let det of detenteurs) {
    toExport.push({
      Index: index,
      'Code client': det.code_referent,
      Nom: det.nom,
      Prénom: det.prenom,
      Email: det.email,
      Adresse: det.adresse,
      Nationalité: det.nationalite,
      Téléphone: det.mobile,
      Gestionnaire: `${det.createur.nom} ${det.createur.prenom}`,
      'Code agence': det.agence.code,
      Agence: det.agence.nom,
      'Code partenaire': det.partenaire.code_referent,
      Partenaire: det.partenaire.nom,
      'Date création': `${moment(det.created_at).format(
        'DD/MM/YYYY HH:mm:ss',
      )}`,
      'Date modification': `${moment(det.updated_at).format(
        'DD/MM/YYYY HH:mm:ss',
      )}`,
    });
    index += 1;
  }

  return toExport;
};

export const exportDetenteurData = (
  detenteurs: DetenteurEntity[],
  format: ExportFormat,
  metadata?: ExportMetadata,
) => {
  const detenteursData = generateDetenteurDataToExport(detenteurs);

  exportPremiumFile({
    fileName: 'Etat des clients',
    metadata,
    title: 'Etat des clients',
    sheets: [{ data: detenteursData, name: 'Clients' }],
  }, format);
};
